function getTimeAgo(timestamp) {
    if(!timestamp) return `-`;
    
    const now = new Date();
    const past = new Date(timestamp);
 
    const diffMs = now - past;
 
    const sec = Math.floor(diffMs / 1000);
    if (sec < 1) return "just now";
    if (sec < 60) return `${sec} sec${sec > 1 ? 's' : ''} ago`;
 
    const min = Math.floor(sec / 60);
    if (min < 60) return `${min} min${min > 1 ? 's' : ''} ago`;
 
    const hr = Math.floor(min / 60);
    if (hr < 24) return `${hr} hour${hr > 1 ? 's' : ''} ago`;
 
    const day = Math.floor(hr / 24);
    if (day < 30) return `${day} day${day > 1 ? 's' : ''} ago`;
 
    const month = Math.floor(day / 30);
    if (month < 12) return `${month} month${month > 1 ? 's' : ''} ago`;
 
    const year = Math.floor(month / 12);
    return `${year} year${year > 1 ? 's' : ''} ago`;
}

module.exports = {
    getTimeAgo
}